import CitizenshipWrapper from 'features/reactivation/screens/Citizenship/CitizenshipWrapper';
import React from 'react';

export default function ReactivationAddressPage() {
  return <CitizenshipWrapper />;
}
